import { AccessoryAddedSystem } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';

const revertTransparentDrawers = ({ coreApi }: BehaviorParameters) => {
  coreApi.getSystem<AccessoryAddedSystem>('AccessoryAddedSystem')?.removeClippingFromAllDrawers();
};

export default revertTransparentDrawers;
